import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore.js'
// import HomeView from '../views/HomeView.vue'
// import ContactView from '../views/ContactView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
    meta: { title: 'Practice German online' }
  },
 
  {
    path: '/:lang/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: { title: 'About Practice German online' }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: { title: 'Register' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { title: 'Login' }
  } ,
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/LogoutView.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { requiresAuth: true, isAdmin: true, title: 'Admin Dashboard' },
    component: () => import('../views/admin/AdminView.vue')
  },
  {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue'),
      meta: { requiresAuth: true, title: 'Contact - German Learning' }
    },
    {
      path: '/user-profile',
      name: 'user-profile',
      component: () => import('../views/UserProfileView.vue'),
      meta: { requiresAuth: true, title: 'User Profile - German Learning' }
    },
  
  
  {
    path: '/Practice-reading-German-with-pronunciation-rules/:id?/:name?',
    name: 'GermanPronunciation',
    component: () => import('@/views/GermanPronunciationView.vue'),
    meta: { title: 'Practice reading German with pronunciation rules' }
  },
  {
    path: '/german-vocabulary-flashcards/:word_id?/:word?',
    name: 'GermanVocabulary',
    component: () => import('@/views/GermanVocabularyView.vue'),
    meta: { title: 'Learn German with flashcards German Vocabulary' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to) => {
  console.log('%c to  . (1743452975) ', 'color:lightgreen;', to)

  const store = useUserStore()
  //console.log('%c isLoggedIn  . (1071125686)', 'color:lightblue;', store.isLoggedIn)

  // Redirect if authentication is required and user is not logged in
  if (to.meta.requiresAuth && store.isLoggedIn == false) return '/login'
  if (to.meta.isAdmin && store.user.role_id < 70) return '/login'

  // Set the page title
  if (to.meta.title) {
    document.title = to.meta.title
  }
})
export default router
